var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.col.primaryKey)?_c('router-link',{attrs:{"to":{name: _vm.admin.getEditPage().getRouteName(), params: {id: _vm.row.id}}}},[_vm._v(" "+_vm._s(_vm.formattedValue)+" ")]):_c('span',[_vm._v(_vm._s(_vm.formattedValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }